import { writable } from 'svelte/store';
import { IDLE } from '../common/callState';
let state = {
    callSession: null,
    peer: '',
    state: IDLE,
    ua: null,
    duration: 0,
    notes: '',
    timerInterval: null,
    credentials: {
        domain: '',
        host: '',
        port: '',
        protocol: '',
        username: '',
        password: ''
    },
    sessions: []
};
let call = () => {
    const { subscribe, set, update } = writable(state);
    return {
        subscribe,
        update: (data) => update((store) => (Object.assign(Object.assign({}, store), data))),
        setCredentials: (credentials) => update((store) => (Object.assign(Object.assign({}, store), { credentials }))),
        reset: () => update(() => (Object.assign({}, state))),
    };
};
export default call();
